import {
  utils,
} from '@ama-sdk/core';
import {
  TravelDocument,
} from '@dapi/sdk';
import {
  createAmount,
} from '@dapi/sdk/spec';
import {
  sekCurrency,
} from './currency';
import {
  arnEwhFareInfo,
  fareInfo,
} from './fare';
import {
  arnEwrFlightItem,
} from './flights';
import {
  paymentCard,
  paymentCardCA,
} from './payment';
import {
  cardPaymentTransactionCA,
  milesPaymentTransactions,
  milesPaymentTransactionsWithoutCancellation,
} from './payment-transaction';
import {
  priceWithTaxes,
} from './price';
import {
  arnEwrTaxes,
  multipleTaxesForMiles,
  taxesForPaidAmountWithMiles,
} from './tax';
import {
  traveler,
  traveler2,
  traveler3,
} from './traveler';

export const travelerDocument: TravelDocument = {
  areCouponsAndSegmentsInSync: true,
  creation: {
    triggerEventName: 'issuance',
    localDateTime: new utils.DateTime('2024-02-15T00:00:00.000Z')
  },
  documentType: 'eticket',
  endorsement: 'NON ENDO/ REF -BG EY',
  fareInfos: [fareInfo],
  flightIds: ['ST3'],
  id: '6072160342328',
  paymentTransactions: [{
    paymentMethod: paymentCardCA,
    amount: createAmount({
      template: {
        value: 2795,
        currencyCode: 'AED'
      }
    }),
    authorization: {
      approvalCode: 'APS1OK'
    }
  }],
  price: priceWithTaxes,
  status: 'ISSUED',
  travelerIds: [traveler.id]
};

export const arnEwrTravelerDocuments: TravelDocument[] = [
  {
    flightIds: [arnEwrFlightItem.id],
    travelerIds: [traveler3.id],
    id: '1172457148335',
    documentType: 'eticket',
    price: {
      base: 9445,
      total: 11_213,
      currencyCode: 'SEK',
      taxes: arnEwrTaxes,
      totalTaxes: 1768,
      currency: sekCurrency
    },
    paymentTransactions: [{
      paymentMethod: paymentCard
    }],
    fareInfos: arnEwhFareInfo
  },
  {
    flightIds: [arnEwrFlightItem.id],
    travelerIds: [traveler2.id],
    id: '1172457148334',
    documentType: 'eticket',
    price: {
      base: 12_593,
      total: 14_361,
      currencyCode: 'SEK',
      taxes: arnEwrTaxes,
      totalTaxes: 1768,
      currency: sekCurrency
    },
    paymentTransactions: [{
      paymentMethod: paymentCard
    }],
    fareInfos: arnEwhFareInfo
  },
  {
    flightIds: [arnEwrFlightItem.id],
    travelerIds: [traveler.id],
    id: '1172457148335',
    documentType: 'eticket',
    price: {
      base: 9445,
      total: 11_213,
      currencyCode: 'SEK',
      taxes: arnEwrTaxes,
      totalTaxes: 1768,
      currency: sekCurrency
    },
    paymentTransactions: [{
      paymentMethod: paymentCard
    }],
    fareInfos: arnEwhFareInfo
  }
];

export const travelerDocumentsForMilesRefund: TravelDocument[] = [{
  flightIds: [arnEwrFlightItem.id],
  travelerIds: [traveler.id],
  id: '2202204070136',
  documentType: 'eticket',
  price: {
    base: 0,
    total: 5686,
    currencyCode: 'SEK',
    currency: sekCurrency,
    taxes: taxesForPaidAmountWithMiles,
    totalTaxes: 5686
  },
  paymentTransactions: milesPaymentTransactions,
  fareInfos: arnEwhFareInfo
}];

export const travelerDocumentsForMilesRefundWithoutCancellation: TravelDocument[] = [{
  flightIds: [arnEwrFlightItem.id],
  travelerIds: [traveler.id],
  id: '2202204070136',
  documentType: 'eticket',
  price: {
    base: 0,
    total: 5825,
    currencyCode: 'SEK',
    currency: sekCurrency,
    taxes: multipleTaxesForMiles,
    totalTaxes: 5825,
    priceBreakdowns: [{
      currencyCode: 'NUC',
      amount: '190.00',
      value: 19_000,
      priceQualifier: 'BASE_FARE',
      priceBreakdownType: 'PER_FARE_FAMILY',
      applicability: [{
        id: 'fareInfo-1',
        type: 'fareInfo'
      }]
    }]
  },
  paymentTransactions: milesPaymentTransactionsWithoutCancellation,
  fareInfos: arnEwhFareInfo
},
{
  serviceIds: ['TSM24'],
  travelerIds: [traveler.id],
  id: '2204024940992',
  documentType: 'services',
  price: {
    base: 6500,
    total: 6500,
    currencyCode: 'SEK',
    currency: sekCurrency,
    totalTaxes: 0
  },
  paymentTransactions: cardPaymentTransactionCA
}];

export const travelerDocumentsForMilesRefundWithTwoPax: TravelDocument[] = [
  travelerDocumentsForMilesRefund[0],
  {
    ...travelerDocumentsForMilesRefund[0],
    travelerIds: [traveler2.id],
    id: '2202204070137'
  }
];
